import Modal from "common/Modal/Modal.tsx";
import Flex from "common/Boxes/Flex.tsx";
import Button from "common/Buttons/Button.tsx";
import UserAddOutlined from "@ant-design/icons/UserAddOutlined";
import React, { useState } from "react";
import ManageInvitationsTable from "features/configuration/InviteExternalUsers/ManageInvitationsTable.tsx";
import CreateInvitationModal from "features/configuration/InviteExternalUsers/CreateInvitationModal.tsx";
import useMedia from "utils/hooks/useMedia.ts";
import InvitationCards from "features/configuration/InviteExternalUsers/InvitationCards.tsx";
import { INVITATIONS_MIN_MODAL_WIDTH } from "features/configuration/InviteExternalUsers/constants.ts";

interface ManageInvitationsModal {
  open?: boolean;
  onCancel?: () => void;
}

const ManageInvitationsModal = ({ open, onCancel }: ManageInvitationsModal) => {
  const [inviteModalOpen, setInviteModalOpen] = useState(false);
  const isCards = useMedia(
    [`(max-width: ${INVITATIONS_MIN_MODAL_WIDTH + 60}px)`],
    [true],
    false
  );

  const footer = (
    <Flex $justifyContent="flex-end" style={{ columnGap: 8 }}>
      <Button type="link" onClick={onCancel}>
        Cancel
      </Button>
      <Button
        type="primary"
        onClick={() => setInviteModalOpen(true)}
        icon={<UserAddOutlined />}
      >
        Create Invite
      </Button>
    </Flex>
  );

  return (
    <>
      <Modal
        open={open}
        onCancel={onCancel}
        title="External Users Invitations"
        footer={footer}
        width={isCards ? undefined : INVITATIONS_MIN_MODAL_WIDTH}
        styles={{
          body: isCards
            ? {
                padding: 0,
              }
            : undefined,
        }}
      >
        {isCards ? <InvitationCards /> : <ManageInvitationsTable />}
      </Modal>
      <CreateInvitationModal
        open={inviteModalOpen}
        onCancel={() => setInviteModalOpen(false)}
      />
    </>
  );
};

export default ManageInvitationsModal;
